import Vue from 'vue'
import Router from 'vue-router'

import Login from '../views/Login.vue'
import AdminLayout from '../views/admin/AdminLayout.vue'
import Suppliers from '../views/admin/Suppliers.vue'
import Circles from '../views/admin/Circles.vue'
import Companies from '../views/admin/Companies.vue'
import Segments from '../views/admin/Segments.vue'
import SNs from '../views/admin/SNs.vue'
import VendorLayout from '../views/vendor/VendorLayout.vue'
import VendorProfile from '../views/vendor/VendorProfile.vue'
import VendorCardManage from '../views/vendor/VendorCardManage.vue'
import VendorSegments from '../views/vendor/VendorSegments.vue'
import CreateSN from '../views/vendor/CreateSN.vue'
import MySNs from '../views/vendor/MySNs.vue'
import VerifyForm from '../views/verify/VerifyForm.vue'
import VerifyResult from '../views/verify/VerifyResult.vue'
import VendorCard from '../views/card/VendorCard.vue'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  routes: [
    { path: '/', redirect: '/verify' },
    { path: '/login', component: Login },
    {
      path: '/admin',
      component: AdminLayout,
      meta: { role: 'admin' },
      children: [
        { path: 'suppliers', component: Suppliers },
        { path: 'circles', component: Circles },
        { path: 'companies', component: Companies },
        { path: 'segments', component: Segments },
        { path: 'sns', component: SNs },
        { path: '', redirect: 'suppliers' },
      ],
    },
    {
      path: '/vendor',
      component: VendorLayout,
      meta: { role: 'vendor' },
      children: [
        { path: 'profile', component: VendorProfile },
        { path: 'card', component: VendorCardManage },
        { path: 'segments', component: VendorSegments },
        { path: 'create', component: CreateSN },
        { path: 'sns', component: MySNs },
        { path: '', redirect: 'profile' },
      ],
    },
    { path: '/verify', component: VerifyForm },
    { path: '/verify-result', component: VerifyResult },
    { path: '/card/:vendorCode', component: VendorCard },
  ],
})

router.beforeEach((to, from, next) => {
  if (!to.meta.role) {
    next()
    return
  }
  const role = localStorage.getItem('role')
  const token = localStorage.getItem('token')
  if (!token || role !== to.meta.role) {
    next('/login')
    return
  }
  next()
})

export default router
